import React from "react";
import { positionCloseActions } from "../../hooks/useClosablePosition";

// The CLOSE POSITION row at the top of the expanded quantity menu.
//
// Client, with a mockup: "Caption = verb. Tells the user the chips close, so
// Half / All can't read as 'add.' Chip height, teal outline. Same size as the
// number keys, not solid green — signals populate, not execute. One added row.
// No internal scroll, no wider menu, no second screen."
//
// And on the wording: "Close position is already your locked wording on the
// Holdings card. Reusing it here keeps the platform consistent and teaches the
// same term in two places."
//
// So the VERB lives in the caption and the chips carry only Half / All plus the
// quantity each would fill. That replaces the first build's "Sell Half · 36" /
// "Cover All · 72", where the verb was repeated on both chips and changed
// between long and short — the client's version says it once and says it the
// same way for every position.
//
// The chips are ONE grid row, the same `py-2` and `rounded-lg` the number keys
// use, so the menu grows by exactly one row and never needs to scroll.

// Outline teal, ours: the client specified "teal outline… not solid green" but
// no value, and the app's own teals (#004C50 primaryColor, #006565) are darker
// than the #1a1a2e panel they sit on, so neither is visible here. This is the
// lightest teal that reads as teal rather than green against that panel.
const CHIP_TEAL = "#3FBFB3";

const PositionCloseActions = ({ position, onSelect }) => {
  const actions = positionCloseActions(position);
  if (!actions.length) return null;

  return (
    <>
      {/* "Caption = verb." Same small-caps treatment the app uses for an eyebrow,
          sized to sit quietly above the chips rather than compete with them. */}
      <p className="mb-1.5 px-0.5 text-[10px] font-semibold uppercase tracking-wider text-gray-400">
        Close position
      </p>
      <div className="mb-1.5 grid grid-cols-2 gap-1.5">
        {actions.map((action) => (
          <button
            type="button"
            key={action.key}
            onClick={() => onSelect(action)}
            style={{ borderColor: CHIP_TEAL, color: CHIP_TEAL }}
            className="rounded-lg border bg-transparent py-2 text-center leading-tight transition-colors hover:bg-white/5"
          >
            <span className="block text-sm font-semibold">{action.label}</span>
            <span className="block text-xs opacity-80">{action.quantity}</span>
          </button>
        ))}
      </div>
      {/* Separates the close row from the quantity controls the client asked to
          keep underneath, so the menu reads as two groups rather than one longer
          list of buttons. */}
      <div className="mb-1.5 h-px bg-white/10" />
    </>
  );
};

export default PositionCloseActions;
